import { Toast } from "@/helpers/toastr";

// Same connect flow as the Settings > Shipping card: ask proship-messenger for the Facebook URL with
// redirectUrl = #/settings/shipping, leave for Facebook, and FacebookPagesCard there runs the claim.
export function connectMessengerPage(vm) {
  if (vm.connecting) return;
  vm.connecting = true;
  const redirectUrl = window.location.origin + window.location.pathname + "#/settings/shipping";
  vm.$store.dispatch("messenger/connectUrl", {
    redirectUrl,
    callback: (ok, url) => {
      if (ok && url) {
        window.location.assign(url); // stays "connecting" while the browser leaves for Facebook
        return;
      }
      vm.connecting = false;
      Toast(vm.$t("messenger.pages.connect_failed"), "danger");
    }
  });
}

